export const UsaSectionsData = [
  // {
  //   id: 5,
  //   backgroundImage: "/images/countries/newyork/banner-1.avif",
  //   title: "The Best Development Company Awarded By ",
  //   awardLogo: "/images/payoneer-circle.png",
  //   awardName: "Payoneer",
  //   heading: [
  //     { text: "Hire AI Agents ", isSpan: false },
  //     { text: "to Drive Business Efficiency", isSpan: true },
  //   ],
  //   subHeading:
  //     "Leverage AI agents to optimize processes, enhance customer engagement, & deliver measurable results that accelerate business growth.",
  //   buttonText: "Hire AI Agents",
  //   buttonLink: "/contact-us",
  // },
  {
    id: 6,
    backgroundImage: "/images/countries/newyork/banner-4.avif",
    title: "The Best Development Company Awarded By",
    awardLogo: "/images/payoneer-circle.png",
    awardName: "Clutch",
    heading: [
      { text: "Next-Gen AI Agents ", isSpan: false },
      { text: "That Drive Smarter Business Outcomes", isSpan: true },
    ],
    subHeading:
      "Our next-gen AI agents deliver human-like interactions & workflow automation-helping businesses cut costs, boost efficiency, & scale with ease.",
    buttonText: "LAUNCH YOUR AI ASSISTANT",
    buttonLink: "/contact-us",
  },
  {
    id: 1,
    backgroundImage: "/images/countries/newyork/banner-1.avif",
    title: "The Best Development Company Awarded By ",
    awardLogo: "/images/payoneer-circle.png",
    awardName: "Payoneer",
    heading: [
      { text: "From Complexity to Clarity", isSpan: false },
      { text: "AI-Powered Business Transformation", isSpan: true },
      // { text: " & ", isSpan: false },
      // { text: "Transformative Experiences", isSpan: true },
    ],
    subHeading:
      "From Generative AI development to AI chatbots & intelligent agents, we build scalable solutions that optimize operations & drive smarter business outcomes.",
    buttonText: "Start Your AI Journey",
    buttonLink: "/contact-us",
  },
  {
    id: 2,
    backgroundImage: "/images/countries/newyork/banner-2.avif",
    title: "The Best Development Company Awarded By ",
    awardLogo: "/images/payoneer-circle.png",
    awardName: "Payoneer",
    heading: [
      { text: "Enterprise-Grade Blockchain ", isSpan: false },
      { text: "Solutions for Every Business Stage", isSpan: true },
      // { text: " ", isSpan: false },
      // { text: "Services", isSpan: true },
    ],
    subHeading:
      "As a leading blockchain development company, we specialize in building custom blockchain solutions that maximize your IT investments, streamline operations, & enhance trust across your business ecosystem.",
    buttonText: "Start Your Blockchain Project",
    buttonLink: "/contact-us",
  },
  {
    id: 3,
    backgroundImage: "/images/countries/newyork/banner-3.avif",
    title: "The Best Development Company Awarded By",
    awardLogo: "/images/payoneer-circle.png",
    awardName: "Clutch",
    heading: [
      { text: "Building Custom Mobile ", isSpan: false },
      { text: "Apps That Drive Business Growth", isSpan: true },
      // { text: " & ", isSpan: false },
      // { text: "", isSpan: true },
    ],
    subHeading:
      "As a top mobile application development company, we design, build, & maintain applications that drive results. Our expert mobile app developers help startups, SMBs, & enterprises accelerate digital growth.",
    buttonText: "Launch Your Custom Mobile App",
    buttonLink: "/contact-us",
  },
  {
    id: 4,
    backgroundImage: "/images/countries/newyork/banner-4.avif",
    title: "The Best Development Company Awarded By",
    awardLogo: "/images/payoneer-circle.png",
    awardName: "Clutch",
    heading: [
      { text: "From Concept to Code ", isSpan: false },
      { text: "Software Solutions Built Around You", isSpan: true },
      // { text: " & ", isSpan: false },
      // { text: "Exceptional User Experiences", isSpan: true },
    ],
    subHeading:
      "Our software consulting services guide businesses in strategy, planning, & execution of custom software development projects to ensure technology investments deliver maximum business impact.",
    buttonText: "Schedule Your Consultation",
    buttonLink: "/contact-us",
  },
];

export const UsaScrollerData = [
  {
    text: "Recognition",
    link: "testimonial-section",
  },
  {
    text: "Hire Us",
    link: "hire-us",
  },
  {
    text: "Why Us",
    link: "why-us",
  },
  {
    text: "Our Stacks ",
    link: "our-stacks",
  },
  {
    text: "IT Services",
    link: "it-services",
  },
  {
    text: "Models",
    link: "engagment-models",
  },
  {
    text: "Industries ",
    link: "pioner-change-box",
  },
  {
    text: "Our Core Team",
    link: "our-team",
  },
  {
    text: "Insights",
    link: "trends",
  },
  {
    text: "Locations",
    link: "our-locations",
  },
];
